import { navigate } from 'gatsby';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import RoundedButton from '@components/RoundedButton/index';

import * as ROUTES from '@constants/routes';

import { useSession } from '@hooks/useSession';

import Image404 from '@images/404.png';

import { PageStyle } from './NotFound.style';

export default function Page404() {
  const {
    state: { isAuthenticated },
  } = useSession();
  const handleClick = () => {
    if (!isAuthenticated) {
      return navigate(ROUTES.LOGIN);
    }
    return navigate(ROUTES.DASHBOARD);
  };
  return (
    <PageStyle>
      <img alt="404" src={Image404} />
      <h1>
        <FormattedMessage
          defaultMessage="Page not found"
          id="404.pageNotFound"
        />
      </h1>
      <h3>
        <FormattedMessage
          defaultMessage="Sorry, we can't find that page. It might be an old link or the page could have moved."
          id="404.sorryCantFindPage"
        />
      </h3>
      <RoundedButton onClick={handleClick} width="260px">
        <FormattedMessage defaultMessage="Back to home" id="404.backToHome" />
      </RoundedButton>
    </PageStyle>
  );
}
